const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const formElementFields = [
  {
    id: "name",
    label: "Name",
    placeHolder: "",
    type: "text",
    md: 12,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
  },
  {
    id: "emailContact",
    label: "Email",
    placeHolder: "Enter email ID",
    type: "text",
    // isRequired: true,
    md: 12,

  },
  {
    id: "phone",
    label: "Phone No.",
    placeHolder: "Enter phone number",
    type: "contact",
    md: 12,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
];

export const allFormElementFields = [
  {
    id: "name",
    label: "Name",
    placeHolder: "",
    type: "text",
    md: 6,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    isRequired: true,
  },
  {
    id: "contactName",
    label: "Contact Name",
    placeHolder: "",
    type: "text",
    md: 6,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    // isRequired: true,
  },
  {
    id: "emailContact",
    label: "Email",
    placeHolder: "Enter email ID",
    type: "text",
    // isRequired: true,
    md: 6,

  },
  {
    id: "phone",
    label: "Phone No.",
    placeHolder: "Enter phone number",
    type: "contact",
    md: 6,
    inputProps: {
      maxLength: 11,
    },
    patternAllowed: patternConstant?.NUMERIC,
  },
  {
    id: "notes",
    label: "Notes",
    placeHolder: "",
    type: "text",
    md: 12,
    inputProps: {
      maxLength: 255,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
    // isRequired: true,
  },
];
